import Accordion from "react-bootstrap/Accordion"

//imported in pages/course-details.js
export default function CourseContentAccordion() {
    return (
        <Accordion className="mb-5">
            {[
                { 
                    title: "HTML and CSS", eventKey:"0", body:`Get to know the basics of HTML document structure and elements. Then continue with styling HTML elements using basic CSS declarations.
                    <ol>
                        <li>HTML tags and elements</li> 
                        <li>HTML formatting</li>
                        <li>Inline CSS and stylesheets</li>
                        <li>CSS framework Bootstrap</li>
                        <li>Website layout and design</li>
                    </ol>`
                },
                {   title: "CLI and Python", eventKey:"1", body:`It's time to learn more about coding using a command line interface (CLI) and Python Programming Language examples.
                    <ol>
                        <li>Command Line Interface</li>
                        <li>Python setup</li>
                        <li>Python exercises</li>
                    </ol>` 
                },
                { 
                    title: "Django I",  eventKey:"2", body:`Now that you have a grasp on using CLI and Python, let's jump into installing Django and setting up your first web app.
                    <ol>
                        <li>Django installation and configuration</li>
                        <li>Django overview and debugging</li>
                        <li>Django + Bootstrap</li>
                        <li>Django functionality I</li>
                        <li>Django functionality II</li>
                    </ol>` 
                },
                { 
                    title: "Django II", eventKey:"3", body:`Further increase your web app functionality with the Django template language, Python packages and other built-in Django features.
                    <ol>
                        <li>Django user registration</li>
                        <li>Python packages + Django messages</li>
                        <li>User login + logout</li>
                        <li>Creating a blog</li>
                        <li>Updating the homepage</li>
                    </ol>` 
                },
                { 
                    title: "Django III", eventKey:"4", body:`Create a user page and allow users to submit product reviews. Then increase the app's mobile compatibility with media queries.
                    <ol>
                        <li>Django custom user profile</li>
                        <li>User-submitted content</li>
                        <li>Finishing touches</li>
                    </ol>` 
                },
                {   title: "Deploying Django",  eventKey:"5", body:`Add the final configuration settings to your project and deploy your Django web app using Amazon Web Services (AWS).
                    <ol>
                        <li>Deployment configurations</li>
                        <li>Deploying to AWS Elastic Beanstalk</li>
                        <li>Web development next steps</li>
                        <li>Custom domains + Security configurations</li>
                    </ol> ` 
                }
                ].map(({ title, body, eventKey }) => (
                    <Accordion.Item eventKey={eventKey} key={eventKey}>
                        <Accordion.Header>{title}</Accordion.Header>
                        <Accordion.Body>
                            <div dangerouslySetInnerHTML={{ __html: body }}></div>
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
        </Accordion>
    )
}